import { DateHelper, DateFormat } from '@meltingpoint/lastmile-internationalization'

const DEFAULT_CUSTOMER_TIMEZONE = 'Europe/Paris'
const dateHelper = new DateHelper('fr', DEFAULT_CUSTOMER_TIMEZONE)

export { dateHelper, DateFormat, DEFAULT_CUSTOMER_TIMEZONE }
